import { render } from "./CappCoPayment.vue?vue&type=template&id=07c64ad1&ts=true"
import script from "./CappCoPayment.vue?vue&type=script&lang=ts"
export * from "./CappCoPayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__